import { createContext, useContext, useEffect, useState } from "react";
import React from 'react'
const TodoContext = createContext();



const TodoContextProvider = ({ children }) => {
 
 const name="Isha"



 const [modal, setModal] = useState(false);

 const toggle = () => setModal(!modal);
 
 const [taskList,setTaskList]=useState([]);
  
 const loadTasks=()=>{
   let arr=JSON.parse(localStorage.getItem("taskList"));
   if(arr){
     setTaskList(arr)
   }
 }
 useEffect(()=>{
  loadTasks();
 },[])

// *****************saveTask*************************

 const saveTask=(task)=>{
   let tempList=taskList;
   tempList.push(task);
   setTaskList(tempList)
   localStorage.setItem("taskList",JSON.stringify(tempList))
   console.log("TaskList",taskList)
   setModal(false)
}

//  *********************Delete Task**************************
const deleteTask=(index)=>{
   let tempList=taskList;
   tempList.splice(index,1);
   setTaskList(tempList);
   localStorage.setItem("taskList",JSON.stringify(tempList));
   console.log("taskList After delete",taskList)
   loadTasks();

}

//******************************Update Task**************************/
const updateListArray=(task,index)=>{
 let tempList=taskList;
 tempList[index]=task;
 setTaskList(tempList)
 localStorage.setItem("taskList",JSON.stringify(tempList));
 setModal(false)
 loadTasks();
}


// *************************Update a single value ************************
const upddateFav=(index,val)=>{
  
   console.log("favvalue",val,index)
   let tempList=taskList;
   tempList[index].favourite=val;
   console.log("favlist id",tempList[index].favourite);
}

    return (
        <TodoContext.Provider value={{name,setModal,modal,toggle,taskList,setTaskList,
         loadTasks,updateListArray,deleteTask,saveTask,upddateFav
        }}>
            {children}
        </TodoContext.Provider>
    )
}

const useTodoContext=()=>{
    return useContext(TodoContext)
}
export {TodoContext,TodoContextProvider,useTodoContext}